import { useCallback } from 'react';
import { useAtom } from 'jotai';
import { ButtonGroup } from '@antimatterhq/ui/components/buttonGroup';
import { Icon } from '@antimatterhq/ui/components/icon';
import {
  DataSourceViewMode,
  dataSourceViewModeAtom,
} from '@/atoms/dataSources/dataSourcesAtoms';

const isDataSourceViewMode = (value: string): value is DataSourceViewMode => {
  return value === 'card' || value === 'table';
};

export const DataSourceViewModeToggle = () => {
  const [viewMode, setViewMode] = useAtom(dataSourceViewModeAtom);

  const handleViewModeChange = useCallback(
    (value?: string) => {
      if (!value) throw new Error('Value is required');
      if (!isDataSourceViewMode(value)) throw new Error('Invalid value');

      setViewMode(value as DataSourceViewMode);
    },
    [setViewMode],
  );

  return (
    <ButtonGroup
      options={[
        {
          label: <Icon icon="radix-icons:grid" />,
          value: 'card',
        },
        {
          label: <Icon icon="radix-icons:list-bullet" />,
          value: 'table',
        },
      ]}
      value={viewMode}
      onChange={handleViewModeChange}
      buttonClassName="min-w-[0px] h-[36px] w-[40px]"
    />
  );
};
